<div class="d-flex flex-grow-1 flex-column py-4">
  <div class="d-flex flex-grow-1 flex-row">
    <div class="flex-grow-1 player-box ml-5 ">
      <app-player-info [player]="player"></app-player-info>
    </div>
    <div class="mt-3 mx-3"><span class="ic-player-right"></span></div>
    <div class="flex-grow-1 mr-5" [ngClass]="{'player-box-red': anyRulesExceeded, 'player-box':!anyRulesExceeded}">
      <app-player-info [player]="changedPlayer"></app-player-info>
    </div>
  </div>
  <div class="mx-5 mt-3">
    <app-player-rules-message *ngIf="playerRules" [rules]="playerRules" [categoryName]="categoryName">
    </app-player-rules-message>
  </div>
</div>
